import { AutogenModelArinquiry, AutogenRowArinquiry } from "./autogen/AutogenModelArinquiry";

export class ModelArinquiry extends AutogenModelArinquiry<RowArinquiry> {
    constructor() {
        super(RowArinquiry);
    }
}

export class RowArinquiry extends AutogenRowArinquiry {
}